export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38')
];

export const server_loads = [];

export const dictionary = {
		"/": [3],
		"/(app)/analyze/live-ledger": [4,[2]],
		"/(app)/analyze/report/[reportKey]": [5,[2]],
		"/(app)/analyze/risk-position": [6,[2]],
		"/auth-callback": [35],
		"/(app)/hedge/charts-and-quotes": [7,[2]],
		"/(app)/hedge/futures-first": [8,[2]],
		"/(app)/hedge/futures-ps": [9,[2]],
		"/(app)/hedge/futures-sync": [10,[2]],
		"/(app)/hedge/hedge-desk/[[orderId]]": [11,[2]],
		"/(app)/help/support-request": [12,[2]],
		"/login": [36],
		"/(app)/manage/bidsheet": [13,[2]],
		"/(app)/manage/contracts/[[contractId]]": [14,[2]],
		"/(app)/manage/customer-quick-view": [15,[2]],
		"/(app)/manage/offers/[[offerId]]": [16,[2]],
		"/(app)/manage/quick-bids": [17,[2]],
		"/(app)/notifications-history": [18,[2]],
		"/(app)/settings/broker-mapping": [19,[2]],
		"/(app)/settings/bypass-review": [20,[2]],
		"/(app)/settings/commodities": [21,[2]],
		"/(app)/settings/customers": [22,[2]],
		"/(app)/settings/employees": [23,[2]],
		"/(app)/settings/erp": [24,[2]],
		"/(app)/settings/hedge-mapping": [25,[2]],
		"/(app)/settings/locations": [26,[2]],
		"/(app)/settings/mobile-app-approved-months": [27,[2]],
		"/(app)/settings/notifications": [28,[2]],
		"/(app)/settings/ntc-admin": [29,[2]],
		"/(app)/settings/order-entry": [30,[2]],
		"/(app)/settings/regions": [31,[2]],
		"/(app)/settings/rounding-rules": [32,[2]],
		"/(app)/settings/service-fees": [33,[2]],
		"/(app)/settings/user-roles": [34,[2]],
		"/transactions": [37],
		"/transactions/contracts": [38]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';